import { C_ACTION } from '../constans';

//let new_state;

export const assemblies = (state = [], action) => {
  switch (action.type) {
    case C_ACTION.ADD_ASSEMBLIES: {
      return [...action.data];
    }

    case C_ACTION.ADD_ASSEMBLY: {
      return [...state, action.data];
    }

    default:
      return state;
  }
};
